var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24.141,
  height: 24.141,
  viewBox: "0 0 24.141 24.141"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1065 -240.859)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1065 240.859)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.141,
  height: 24.141,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.786 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.285,24.141a1.722,1.722,0,0,1-1.741-1.7V21.312H.87a.849.849,0,1,1,0-1.7h.678V9.053a7.6,7.6,0,0,1,6.866-7.5V.848a.871.871,0,0,1,1.741,0v.708a7.6,7.6,0,0,1,6.867,7.5V19.615H17.7a.849.849,0,1,1,0,1.7H11.026v1.132A1.722,1.722,0,0,1,9.285,24.141Zm0-20.935a5.929,5.929,0,0,0-6,5.846V19.615H15.281V9.053A5.929,5.929,0,0,0,9.285,3.207Z",
  transform: "translate(0 0)",
  fill: "#dd2525"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 13,
  transform: "translate(1070 248)",
  fill: "#dd2525"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 4.5,
  rx: 6,
  ry: 4.5,
  transform: "translate(1071 244)",
  fill: "#dd2525"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(1080 243)",
  fill: "#ffa0a0"
}))));
export default __webpack_public_path__ + "static/media/notifications-snapshot.7dd4ead0.svg";
export { SvgComponent as ReactComponent };